<template>
    <v-dialog v-model="addCommonDataDialog" @keydown.esc="addCommonDataDialog = false" persistent max-width="600px" retain-focus>
        <template v-slot:activator="{ on, addCommonDataAttrs }">
                <v-icon :color="groupSetting.mainColor" class="mt-1" v-bind="addCommonDataAttrs" v-on="on">mdi-account-plus</v-icon>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">{{ name }} 등록</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="6" class="mb-n5">
                            <v-text-field label="옵션명 *" hint="옵션명을 입력하세요." v-model="commonDataAttrs.name" ref="name" @focus="$event.target.select()" required></v-text-field>
                        </v-col>
                        <v-col cols="6" class="mb-n5">
                            <v-text-field label="값 *" hint="값을 입력하세요." v-model="commonDataAttrs.value" required></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mb-n5">
                            <v-text-field label="정렬순서" hint="정렬순서를 숫자로 입력하세요." v-model="commonDataAttrs.priority" required></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
                <v-file-input
                    show-size
                    v-model="csvData"
                    accept="text/csv"
                    label="CSV 파일을 첨부해주세요"
                    ref="file"
                    @change="handleFile"
                ></v-file-input>
                <small class="ml-3">* 항목은 필수입니다.</small>
                <small class="ml-3">CSV 첨부 시 입력값은 무시됩니다.</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="saveCommonData">저장</v-btn>
                <v-btn color="blue darken-1" text @click="addCommonDataDialog = false">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";

export default {
    name: 'AddCommonDataButton',
    props: {
        code: {},
        name: {},
        category: {},
    },
    data: function() {
        return {
            addCommonDataDialog: false,
            commonDataAttrs: {
                id: null,
                code: this.code,
                name: null,
                value: null,
                priority: 0,
                category: this.code == 'paper1' || this.code == 'paper2' ? this.category : ''
            },
            commonDataArray: [],
            groupSetting: null,
            csvData: [],
        }
    },
    watch: {
        code: (code) => {
            this.code = code
        }
    },
    methods: {
        async saveCommonData() {

            if(this.csvData.length == 0){

                if(!this.commonDataAttrs.name){
                    alert('옵션명을 입력해주세요.')
                    return false
                }

                if(!this.commonDataAttrs.value){
                    alert('값을 입력해주세요.')
                    return false
                }

                return axios({
                    method: 'POST',
                        headers: {
                            'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                        },
                        url: this.$store.getters.getApiUrl + '/api/v1/setting/commonData/save',
                        data: this.commonDataAttrs,
                        timeout: this.$store.getters.getApiRequestTimeLimit
                    })
                .then(response => {

                    if(response.data != null && response.data.status == '0000'){

                        alert('정상적으로 추가되었습니다.')
                        this.$emit('click')
                        this.clearData()

                    }else{
                        //
                    }

                })
                .catch(() => {

                    //뭔가 실패 시
                    alert('옵션 저장에 실패했습니다.')
                    console.log(this.$el)
                    this.$rollbar.error('견적 옵션 저장 실패', this.$el)

                })

            }else{
                this.uploadCSV()
            }

        },
        clearData() {
            this.commonDataAttrs.id = null
            this.commonDataAttrs.code = this.code
            this.commonDataAttrs.name = null
            this.commonDataAttrs.value = null
            this.commonDataAttrs.priority = null
            this.csvData = null
        },
        handleFile() {
            const fileCount = (this.$refs.file && this.$refs.file.files) ? this.$refs.file.files.length : 0
            if(fileCount > 0){
                for(let i = 0; i < fileCount; i++){
                    this.csvData.push(this.$refs.file.files[i])
                }
            }
        },
        uploadCSV() {

            if(confirm('CSV 업로드 시 기존 데이터가 모두 초기화됩니다.\n그래도 진행하시겠습니까?')){

                let formData = new FormData()
                formData.append('csvData', this.csvData)

                let additional = ''
                if(this.code == 'paper1' || this.code == 'paper2'){
                    // formData.append('category', this.category)
                    additional = '?category=' + this.category
                }
                
                return axios({
                    method: 'POST',
                    headers: {
                        'Authorization': 'bearer ' + this.$store.getters.getAccessToken,
                        'Content-Type': 'multipart/form-data'
                    },
                    url: this.$store.getters.getApiUrl + '/api/v1/setting/commonData/uploadCSV/' + this.code + additional,
                    data: formData,
                    timeout: this.$store.getters.getApiRequestTimeLimit
                })
                .then(response => {

                    if(response.data != null && response.data.status && response.data.status == '0000'){

                        alert('정상적으로 입력되었습니다.')
                        this.$emit('click')
                        this.clearData()
                        this.addCommonDataDialog = false

                    }else{

                        alert(response.data.message)
                        return false

                    }

                })
                .catch((error) => {

                    if(error && error.name == "InvalidJwtToken"){

                        //JWT 토큰이 정확하지 않을 시
                        alert('인증 토큰이 유효하지 않습니다.')
                        return false

                    }else{

                        //저장 실패 시
                        alert('CSV 입력에 실패했습니다.\n다시 시도해주세요.')

                    }

                })
            }

        },
    },
    created: function() {
        this.groupSetting = this.$store.getters.getGroupSetting
    }
}
</script>